import React, { useState } from "react"
import styled from "styled-components"
import { RightArrowAlt } from "@styled-icons/boxicons-regular"
import {
	Container,
	Row,
	Relative,
	LeftImage,
	Overlay,
	Absolute,
	Text,
	Link,
	RightImage,
	AbsoluteMobile,
} from "./ImageShop.styles"

export const ImageShop = ({ data }) => {
	const rightImage = data.primary.right_image?.url
	const backGround = data.primary.left_image?.url
	const text = data.primary.title1[0]?.text
	const link = data.primary.shop_link?.url
	const [isShown, setIsShown] = useState(false)
	const [isShownRight, setIsShownRight] = useState(false)
	const rightLink = data.primary.right_link?.url
	const rightTitle = data.primary.right_title[0]?.text

	const leftShopify = data.primary.left_link_shopify?.handle
	const rightShopify = data.primary.right_link_shopify?.handle

	const fullUrlLeft = "https://milligram.com/products/" + leftShopify + ""
	const fullUrlRight = "https://milligram.com/products/" + rightShopify + ""

	let leftUrl
	if (leftShopify) {
		leftUrl = fullUrlLeft
	} else {
		leftUrl = link
	}

	let rightUrl
	if (rightShopify) {
		rightUrl = fullUrlRight
	} else {
		rightUrl = rightLink
	}

	return (
		<>
			<Container>
				<Row>
					<a href={leftUrl}>
						<Relative
							onMouseEnter={() => setIsShown(true)}
							onMouseLeave={() => setIsShown(false)}
						>
							<LeftImage src={backGround}></LeftImage>
							{isShown && (
								<>
									<Overlay></Overlay>
									<Absolute>
										<Text>{text}</Text>
										<Link href={leftUrl}>SHOP NOW</Link>
										<RightArrowAlt size="15" />
									</Absolute>
								</>
							)}
						</Relative>
					</a>
					<AbsoluteMobile>
						<Text>{text}</Text>
						<Link href={leftUrl}>SHOP NOW</Link>
						<RightArrowAlt size="15" />
					</AbsoluteMobile>

					<a href={rightUrl}>
						<Relative
							onMouseEnter={() => setIsShownRight(true)}
							onMouseLeave={() => setIsShownRight(false)}
						>
							<RightImage src={rightImage}></RightImage>
							{isShownRight && (
								<>
									<Overlay></Overlay>
									<Absolute>
										<Text>{rightTitle}</Text>
										<Link href={rightUrl}>SHOP NOW</Link>
										<RightArrowAlt size="15" />
									</Absolute>
								</>
							)}
						</Relative>
					</a>
					<AbsoluteMobile>
						<Text>{rightTitle}</Text>
						<Link href={rightLink}>SHOP NOW</Link>
						<RightArrowAlt size="15" />
					</AbsoluteMobile>
				</Row>
			</Container>
		</>
	)
}
